import React from 'react';

import { observer } from 'mobx-react';
import { useFlexLayout, useTable, TableInstance } from 'react-table';
import { ExclusionWindow } from '@bringg/types';
import { BringgReactTable, BasicTableContainer, ListChildRow, BaseRecord } from '@bringg-frontend/bringg-react-table';

import { useGetExclusionWindowsTableColumns } from './use-get-exclusion-windows-table-columns';

import styles from './exclusion-window-table.module.scss';

interface Props {
	format: string;
	selectedTeamId: number;
	exclusionWindows: ExclusionWindow[];
	timezone: string;
	openExclusionWindowModalWithEditMode: (id: number) => void;
	onDeleteOpenConfirmModal: (id: number) => void;
	tableLoading: boolean;
}

const ExclusionWindowTable = ({
	format,
	exclusionWindows,
	timezone,
	openExclusionWindowModalWithEditMode,
	onDeleteOpenConfirmModal,
	tableLoading,
	selectedTeamId
}: Props) => {
	const columns = useGetExclusionWindowsTableColumns({
		format,
		timezone,
		selectedTeamId,
		openExclusionWindowModalWithEditMode,
		onDeleteOpenConfirmModal
	});

	const tableInstance = useTable<ExclusionWindow>(
		{
			columns,
			data: exclusionWindows
		},
		useFlexLayout
	);

	return (
		<div data-test-id={'exclusion-windows-table-container'}>
			<BringgReactTable
				className={styles.bringgReactTable}
				TableContainerComponent={BasicTableContainer}
				RenderRow={props => <ListChildRow {...props} autoColumnWidth />}
				tableInstance={tableInstance as unknown as TableInstance<BaseRecord>}
				sticky={false}
				isLoadingMoreItems={tableLoading}
			/>
		</div>
	);
};

export default observer(ExclusionWindowTable);
